<template>
  <div class="sidebar" :class="{ showSideBar: showSideBar }">
    <div class="sidebar__container">
      <div class="sidebar__container-menu-head">
        <div class="head-img" @click="goToPickupBox">
          <img src="@/assets/icons/Apoteket.svg" alt="Apoteket" />
        </div>
        <div class="head-block" @click="goToEditPharmacy">
          <p class="pharmacy-name">{{ pharmacy?.name }}</p>
          <div class="head-block-edit">
            <img src="@/assets/icons/EditGreen.svg" alt="Edit" />
            <p>{{ $t('edit') }}</p>
          </div>
        </div>
      </div>
      <nav class="sidebar__container-menu-nav">
        <router-link
          :class="{
            'router-link': true,
            'router-link-none': showElementsSideBar(el.translation)
          }"
          v-for="el in routesConfig"
          :key="el.name"
          :to="{ name: el.name }"
          @click="goTo(el.name)"
        >
          <img :src="require(`@/assets/icons/${el.name}.svg`)" alt="" />
          <p>{{ $t(`${el.translation}`) }}</p>
        </router-link>
        <a
          class="link-userGuide"
          href="https://remomedi.com/apoteket/bruksanvisningar/"
          target="_blank"
        >
          <img :src="require(`@/assets/icons/UserGuide.svg`)" alt="" />
          <p>{{ $t('userGuide') }}</p>
        </a>
      </nav>
      <Logout />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import 'firebase/compat/auth';

import Logout from '@/pages/Auth/Logout.vue';

import router from '@/router';

import { routesConfig } from './configs';

@Options({
  components: {
    Logout
  },
  data() {
    return {
      showSideBar: false,
      routesConfig,
      pharmacyId: ''
    };
  },
  computed: {
    ...mapState('account', ['user']),
    ...mapState('pharmacy', ['pharmacy'])
  },
  created() {
    if (this.user) {
      this.show();
    }
  },
  methods: {
    ...mapActions('pharmacy', ['getPharmacy']),
    async show() {
      const userRole = this.user?.role.name;

      if (userRole !== 'janitor' && userRole !== 'chain_admin') {
        await this.getPharmacy(this.user?.pharmacyId);
      }
    },
    toggleSidebar(): void {
      this.showSideBar = !this.showSideBar;
    },
    showElementsSideBar(name: string) {
      const { remomediServices } = this.pharmacy || {};

      const userRole = this.user?.role.name;

      const isJanitor = 'janitor';
      const isChain = 'chain_admin';

      const conditions: Record<string, unknown> = {
        sensors: !remomediServices?.sensors,
        customersFeedback:
          userRole === isChain
            ? false
            : !remomediServices?.feedback || userRole === isJanitor
      };

      return conditions[name] ?? false;
    },
    goTo(name: string) {
      if (name === 'PickupBoxes') {
        router.push({
          name: 'Lockers',
          params: {
            id: this.user?.pharmacyId,
            boxId: this.pharmacy?.pickupBoxes[0]
          }
        });
      }
    },
    goToPickupBox() {
      router.push({
        name: 'Lockers',
        params: {
          id: this.user?.pharmacyId,
          boxId: this.pharmacy?.pickupBoxes[0]
        }
      });
    },
    goToEditPharmacy() {
      this.pharmacyId = this.user.pharmacyId;
      router.push({ name: 'EditPharmacy', params: { id: this.pharmacyId } });
    }
  },
  watch: {
    user: {
      handler(newVal) {
        if (newVal) {
          this.show();
        }
      },
      immediate: false
    }
  }
})
export default class Sidebar extends Vue {}
</script>

<style lang="scss">
.sidebar {
  max-width: 208px;
  min-width: 208px;
  height: 100vh;
  border-right: 1px solid $active;
  .sidebar__container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    background-color: $light-grey;
    outline: none !important;
  }
}

.sidebar__container-menu-head {
  display: flex;
  align-items: center;
  padding: 24px;
  padding-bottom: 0;
  background-color: $light-grey;
  .head-img {
    width: 42px;
    height: 40px;
    margin-right: 14px;
    border: 1px solid $active;
    border-radius: 7px;
    text-align: center;
    background: $white;
    cursor: pointer;
    img {
      margin: 11px;
    }
  }
  .head-block {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: $light-grey;
    cursor: pointer;
    p {
      font-size: $fourteenSize;
      line-height: $fourteenSize;
      font-family: 'Ubuntu-Medium';
      background-color: $light-grey;
    }
    .head-block-edit {
      display: flex;
      align-items: center;
      margin-top: 6px;
      background-color: $light-grey;
      cursor: pointer;
      img {
        background-color: $light-grey;
      }
      p {
        margin-left: 5px;
        color: $main-green;
      }
    }
  }
}

.sidebar__container-menu-nav {
  display: flex;
  flex-direction: column;
  background-color: $light-grey;
  .router-link {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    background-color: $light-grey;
    &.router-link-none {
      display: none;
    }
    &:first-child {
      margin-top: 10px;
      margin-bottom: 50px;
    }
    &.router-link-active,
    &.router-link-active p,
    &.router-link-active img {
      background-color: $active;
    }
    img {
      width: 15px;
      height: 15px;
      margin: 0 12px 0 23px;
      background-color: $light-grey;
    }
    p {
      font-size: $fourteenSize;
      line-height: $fourteenSize;
      font-family: 'Ubuntu-Regular';
      background-color: $light-grey;
    }
    &:hover {
      background-color: $active;
    }
    &:hover p {
      background-color: $active;
    }
    &:hover img {
      background-color: $active;
    }
  }
  .link-userGuide {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    background-color: $light-grey;
    cursor: pointer;
    img {
      width: 15px;
      height: 15px;
      margin: 0 12px 0 23px;
      background-color: $light-grey;
    }
    p {
      font-size: $fourteenSize;
      line-height: $fourteenSize;
      font-family: 'Ubuntu-Regular';
      background-color: $light-grey;
    }
    &:hover {
      background-color: $active;
    }
    &:hover p {
      background-color: $active;
    }
    &:hover img {
      background-color: $active;
    }
  }
  .router-link-exact-active {
    background-color: $active;
    p,
    img {
      background-color: $active;
    }
  }
}
</style>
